import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Cat, Github, Linkedin, Twitter } from "lucide-react";
const footerLinks = [{
  title: "Product",
  links: [{
    label: "AI Builder",
    href: "#"
  }, {
    label: "Templates",
    href: "#"
  }, {
    label: "Pricing",
    href: "#"
  }, {
    label: "Performance",
    href: "#"
  }]
}];
const socialLinks = [{
  icon: Twitter,
  href: "#",
  link: "https://x.com/werkysai",
  label: "Twitter"
}, {
  icon: Github,
  href: "#",
  link: "",
  label: "GitHub"
}, {
  icon: Linkedin,
  href: "#",
  link: "",
  label: "LinkedIn"
}, {
  icon: Cat,
  href: "#",
  link: "",
  label: "Werkys Community"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-background pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="#" className="inline-block mb-6">
              <img src="https://werkys.com/wp-content/uploads/2026/04/mt_monogram_gold_logo.png" alt="Werkys Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm max-w-[200px]">High-speed AI website builder with a playful touch.</p>
          </div>

          {}
          {footerLinks.map((column, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
              
              <ul className="flex flex-col gap-3">Terms of Service<br /><br /><a href='https://werkys.com/privacy-policy'>Privacy Policy</a><li data-index="0" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:ip9by1" data-ast-start="2174" data-ast-end="2246" data-array-file="/src/reusable_sections/Footer.tsx" data-array-name="links" data-array-start-line="88" data-array-end-line="88" data-is-from-array="true" data-is-nested-array="true" data-parent-array-name="footerLinks" data-parent-array-start-line="85" data-parent-array-end-line="85" data-attr-property-mappings="key:j,data-index:j" data-parent-array-index="2" data-array-index="0"></li><li data-index="1" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:ip9by1" data-ast-start="2174" data-ast-end="2246" data-array-file="/src/reusable_sections/Footer.tsx" data-array-name="links" data-array-start-line="88" data-array-end-line="88" data-is-from-array="true" data-is-nested-array="true" data-parent-array-name="footerLinks" data-parent-array-start-line="85" data-parent-array-end-line="85" data-attr-property-mappings="key:j,data-index:j" data-parent-array-index="2" data-array-index="1"></li><li data-index="2" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:ip9by1" data-ast-start="2174" data-ast-end="2246" data-array-file="/src/reusable_sections/Footer.tsx" data-array-name="links" data-array-start-line="88" data-array-end-line="88" data-is-from-array="true" data-is-nested-array="true" data-parent-array-name="footerLinks" data-parent-array-start-line="85" data-parent-array-end-line="85" data-attr-property-mappings="key:j,data-index:j" data-parent-array-index="2" data-array-index="2"></li><li data-index="3" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:ip9by1" data-ast-start="2174" data-ast-end="2246" data-array-file="/src/reusable_sections/Footer.tsx" data-array-name="links" data-array-start-line="88" data-array-end-line="88" data-is-from-array="true" data-is-nested-array="true" data-parent-array-name="footerLinks" data-parent-array-start-line="85" data-parent-array-end-line="85" data-attr-property-mappings="key:j,data-index:j" data-parent-array-index="2" data-array-index="3"></li></ul>
            </div>)}
        </div>

        {}
        <Separator className="mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-muted-foreground text-sm text-center md:text-left">
            © {currentYear} werkys.com. All rights reserved.
          </p>
          
          <div className="flex flex-wrap items-center justify-center md:justify-end gap-6">
            <div className="flex items-center gap-3">
              {socialLinks.map((social, i) => <Button key={i} data-index={i} variant="default" size="icon" className="rounded-2xl shadow-sm hover:shadow-md transition-all" asChild>
                  <a aria-label={social.label} onClick={() => window.open(social.link, "_blank", "noopener,noreferrer")}>
                    <social.icon className="size-4 text-primary-foreground" />
                  </a>
                </Button>)}
            </div>

            <Button asChild className="rounded-full px-6 font-semibold shadow-md hover:shadow-lg transition-all">
              <Link to="#" onClick={() => window.location.href = "https://account.werkys.com/sign-up"}>
                Start Your Free Trial
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}